"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);





var _phone = require('shared/services/phone');


const useCallForwarding = (teamKey) => {
  const setForwardingNumber = _react.useCallback.call(void 0, async (phoneValue) => {
    const parsed = _phone.parsePhoneInputValue.call(void 0, phoneValue)
    if (
      parsed.unsupportedExplicitCallingCode ||
      parsed.callingCode !== '1' ||
      _phone.isPhoneInputTooLong.call(void 0, phoneValue) ||
      !_phone.isCompletePhoneInput.call(void 0, parsed.callingCode, parsed.nationalDigits)
    ) {
      return
    }

    return _actions2.default.updateTeam({
      TeamKey: teamKey,
      ForwardingNumber: _phone.toE164PhoneValue.call(void 0, parsed.callingCode, parsed.nationalDigits),
    })
  }, [teamKey])

  const clearForwardingNumber = _react.useCallback.call(void 0, async () => _actions2.default.updateTeam({
    TeamKey: teamKey,
    ForwardingNumber: '',
  }), [teamKey])

  return { setForwardingNumber, clearForwardingNumber }
}

exports. default = useCallForwarding
